import React, {memo} from 'react';

import './index.scss';

export const BusyIndicator = memo(function BusyIndicator() {
    return (
        <div className='busy-indicator'>
            <div className='loader'>
            </div>
        </div>
    );
});
